export default "__VITE_ASSET__7dd36fbc__"